module.exports = window.wp.apiFetch;